import { render } from "./P016.vue?vue&type=template&id=24bf3eb7&scoped=true"
import script from "./P016.vue?vue&type=script&lang=js"
export * from "./P016.vue?vue&type=script&lang=js"

import "./P016.vue?vue&type=style&index=0&id=24bf3eb7&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bf3eb7"]])

export default __exports__